import { Button } from "rsuite";
import { SvgImport } from "../../assets/icons";
export const ImportUserListButton = () => {
  return (
    <Button
      size="sm"
      appearance="primary"
      className="table-extra-buttons fw-bold disabled"
    >
      <SvgImport /> Import User List
    </Button>
  );
};
